// @ts-check
import { STUDY_TASK_ACTION_TYPES } from '@/constants';
import { utcToLocal } from '@/Helpers/time';
import { required, numeric } from '@vuelidate/validators';
import GroupModel from '@/Models/GroupModel';
import StudyTaskNotificationModel from '@/Models/StudyTaskNotificationModel';

export class StudyTaskModel {
  constructor({
    Id = null,
    GroupId,
    OrganizationId,
    Group = null,
    DaysAfterInclusion,
    Priority,
    AllowedDaysBefore,
    AllowedDaysAfter,
    Automatic = false,
    CardText,
    ModalHeader,
    ModalText,
    ModalButtonText,
    Action,
    ActionLink,
    Done,
    DoneDate,
    PromId,
    PromReference,
    RedcapEventName,
    RedcapRepeatInstrument,
    StudyTaskNotifications = []
  }) {
    this._modelName = 'StudySchemaTask';
    this.Id = Id;
    this.GroupId = GroupId;
    this.OrganizationId = OrganizationId;
    this.Group = Group ? new GroupModel(Group) : null;
    this.DaysAfterInclusion = DaysAfterInclusion;
    this.Priority = Priority;
    this.AllowedDaysBefore = AllowedDaysBefore;
    this.AllowedDaysAfter = AllowedDaysAfter;
    this.Automatic = Automatic;
    this.CardText = CardText;
    this.Action = Action;
    this.ActionLink = ActionLink;
    this.Done = Done;
    this.DoneDate = DoneDate ? utcToLocal(DoneDate) : null;
    this.PromId = PromId;
    this.PromReference = PromReference;
    this.ModalHeader = ModalHeader;
    this.ModalText = ModalText;
    this.ModalButtonText = ModalButtonText;
    this.RedcapEventName = RedcapEventName;
    this.RedcapRepeatInstrument = RedcapRepeatInstrument;
    this.StudyTaskNotifications = StudyTaskNotifications.map(
      sn => new StudyTaskNotificationModel(sn)
    );

    this._isExpanded = false;
  }

  getDeadline(joinedDate) {
    const deadlineDate = joinedDate
      .clone()
      .add(this.DaysAfterInclusion + this.AllowedDaysAfter, 'days');
    return deadlineDate;
  }

  get hasModalContent() {
    return this.ModalHeader?.length > 0 || this.ModalText?.length > 0;
  }

  get actionRoute() {
    var route;
    switch (this.Action) {
      case STUDY_TASK_ACTION_TYPES.PROM:
        route = {
          name: 'promReportEdit',
          params: {
            promid: this.PromId
          }
        };
        break;
      case STUDY_TASK_ACTION_TYPES.SYMPTOMS:
        route = {
          name: 'symptomReport'
        };
        break;
      case STUDY_TASK_ACTION_TYPES.FILE_UPLOAD:
        route = {
          name: 'patientFileUploads'
        };
        break;
    }

    return route;
  }

  __copy() {
    return JSON.parse(JSON.stringify(this));
  }

  static get validations() {
    return {
      Id: {},
      DaysAfterInclusion: {
        required,
        numeric
      },
      Priority: {
        required,
        numeric
      },
      AllowedDaysBefore: {
        required,
        numeric
      },
      AllowedDaysAfter: {
        required,
        numeric
      },
      Automatic: {},
      CardText: {},
      ModalHeader: {},
      ModalText: {},
      ModalButtonText: {},
      Action: { required },
      Done: {},
      PromReference: {},
      RedcapEventName: {},
      RedcapRepeatInstrument: {}
    };
  }
}

export default StudyTaskModel;
